import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class PlantService {

  private baseUrl = `${this.appConfigService.CoreAPIUrl}/plant`;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService) {
  }


  getPlantList() {
    return this.http.get<any>(`${this.baseUrl}/walldisplay/list?page=1&size=999&asc=1`);
  }

  getPlantLocations() {
    return this.http.get<any>(`${this.baseUrl}/ci/list`);
  }
}
